const pwdFieldCtor = require('./utils/pdwFieldCtor');
const selectCountryCtor = require('./utils/selectCountryCtor');

module.exports = {
  AdminInput: require('./admin/Input'),
  AdminInputPassword: pwdFieldCtor(require('./admin/Input')),
  AdminSelect: require('./admin/Select'),
  AdminSelectCountry: selectCountryCtor(require('./admin/Select')),
  AdminDatepicker: require('./admin/Datepicker'),
  AdminSwitch: require('./admin/Switch'),
  AdminCheckbox: require('./admin/Checkbox').default,
  AdminDocumentUploadOnboarding: require('./admin/DocumentUploadOnboarding'),

  MerchantSelect: require('./merchant/Select'),
  MerchantInput: require('./merchant/Input'),
  MerchantInputPassword: pwdFieldCtor(require('./merchant/Input')),
  MerchantInputsCode: require('./merchant/InputsCode'),
  MerchantTextarea: require('./merchant/Textarea'),

  AuthRequestError: require('./auth/RequestError').default,
  AuthInput: require('./auth/Input'),
  AuthInputPassword: pwdFieldCtor(require('./auth/Input')),
  AuthCheckbox: require('./auth/Checkbox').default,
}
